export default {
      id: "video-event_no-safety-belt-usage",
      viewBox: "0 0 20 23",
      url: __webpack_public_path__ + "img/icons.svg#video-event_no-safety-belt",
      toString: function () {
        return this.url;
      }
    }